import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import '@adornis/entity-picker/client/x-entity-picker.js';
import '@adornis/entity-picker/client/x-multi-entity-picker.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import '@chancenwerk/client/components/semantics/chancen-component-semantic-product-picker.js';

@Entity()
export class WorkTrackingStatusAspect extends AbstractAspect {
  static override _class = 'WorkTrackingStatusAspect';

  @Field(() => [String])
  values: Maybe<string[]>;

  constructor(doc: PartialEntityData<WorkTrackingStatusAspect>) {
    const newDoc = doc;
    if (!newDoc.fieldName && !newDoc.customID) newDoc.customID = 'status';
    super(newDoc);
  }

  override getMongoFilter(): object | null {
    return null;
  }
}
